import { StdResponse, request } from "@/global/config/request";
import { AxiosResponse } from "axios"


export function checkFileExists(md5: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/files/md5/${md5}`, {
        params: params,
    })
}

export function getFileUploadUrl(objectName: string, params?: {}): Promise<StdResponse<any>> {
    return request.get(`/objects/upload/url`, {
        params: {
            objectName: `${objectName}`,
            ...params,
        }
    })
}

export function getFileUrl(params?: {}): Promise<AxiosResponse<any>> {
    return request.get(`/objects/url`, {
        params: {
            ...params,
        }
    })
}